import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import inputStyle from "../../styles/input.module.scss";
import { ROOT_SERVER } from "../../utilities/Static";

function DragDropNewArticle({
  images,
  vendor,
  slug,
  setImages,
  setPreviewImage,
}) {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    setImages(
      reorder(images, result.source.index, result.destination.index),
    );
  }

  const handleRemove = (item) => {
    setImages(images.filter((image) => image !== item));
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-new-article" direction="horizontal">
        {(provided) => (
          <div
            className={inputStyle.imagePool}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {images.length >= 1 ? (
              images.map((image, index) => (
                <Draggable key={image} draggableId={image} index={index}>
                  {(dragProvided) => (
                    <div
                      className={inputStyle.dragDropItem}
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      {...dragProvided.dragHandleProps}
                    >
                      <span className={inputStyle.swatchOrderBadge}>
                        {index + 1}
                      </span>
                      <img
                        src={`${ROOT_SERVER}${vendor}/${slug}/thumbnail/${image}`}
                        alt={image}
                        onClick={() => setPreviewImage(image)}
                      />
                      <button
                        type="button"
                        className={inputStyle.folderItemAdd}
                        onClick={() => handleRemove(image)}
                      >
                        Remove from swatch
                      </button>
                    </div>
                  )}
                </Draggable>
              ))
            ) : (
              <div className={inputStyle.dragDropEmpty}>
                Push images from Staging with Add to swatch
              </div>
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default DragDropNewArticle;
